<template>
    <div>
        <page-header :heading="pageHeader.title"
                     :buttons="pageHeader.buttons" />

        <search-form key="claimsSearch1"
                     :inputs="searchInputsEx"
                     class="mb-5"
                     @clear="handleClearClick"
                     @search="handleSearchClick" />
        <hr />
        <div>
            <b-dropdown size="lg" id="claimActions" text="Actions" class="m-md-2">
                <b-dropdown-item @click="handleExportClick">
                    Export
                </b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item :disabled="!(selectedItems && selectedItems.length > 0)"
                                 @click="handleTaskClick">
                    Mark As
                </b-dropdown-item>
            </b-dropdown>
        </div>
        <hr />
        <transition name="fade">
            <select-task v-if="showFlag && (selectedItems && selectedItems.length > 0)"
                         :tasks="taskOptions"
                         :button_text="`Set (${selectedItems.length} records)`"
                         class="mb-2 border-bottom"
                         @button-click="handleUpdateFlagsClick" />
        </transition>

        <transition name="fade">
            <data-list-csv v-if="showExport"
                           class="mb-2 border-bottom"
                           :dataCols="claimsCols"
                           :dataListItems="claimsList"
                           :selectedItems="selectedItems">
            </data-list-csv>

        </transition>

        <div class="row">
            <div class="col">
                <page-size v-model="pageSize"
                           @input="handlePageSizeChange" />
            </div>
            <div class="col">
                <order-by v-model="selectedOrderBy"
                          :options="orderByOptions"
                          @goClick="handleOrderByClick" />
            </div>
        </div>

        <data-list-pagination :dataCols="claimsCols"
                              :dataListItems="claimsList"
                              :showCheckbox="true"
                              :tableClass="'table table-striped table-sm'"
                              :totalRecords="totalRecords"
                              :pageNumber="pageNumber"
                              :pageSize="pageSize"
                              @change="handleSelectedItemsChange"
                              @dbl-click="handleItemDblClick"
                              @pagination-input="handlePagenationInput" />

        <!--<data-list :dataCols="claimsCols"
                   :dataListItems="claimsList"
                   :tableClass="'table table-striped table-sm'"
                   :showCheckbox="true"
                   @change="handleSelectedItemsChange"
                   @dbl-click="handleItemDblClick" />

        <b-pagination align="center"
                      size="md"
                      :total-rows="totalRecords"
                      v-model="pageNumber"
                      :per-page="pageSize"
                      @input="handlePagenationInput" />-->

        <loading :active.sync="isLoading"
                 :can-cancel="false"
                 :is-full-page="true"></loading>
    </div>
</template>

<script>

import claimsSearch from '@/mixins/claimsSearch.js'

import PageHeader from '@/components/PageHeader.vue'
    import DataList from '@/components/DataList.vue'
    import DataListPagination from "@/components/DataListPagination.vue";
import PageSize from '@/components/PageSize.vue'
import DataListCSV from '@/components/DataListCSV.vue'
import SelectTask from '@/components/SelectTask.vue'
import OrderBy from '@/components/OrderBy.vue'
import SearchForm from '@/components/SearchForm.vue'
import { searchInputs } from '@/ui.config/inputs/claimsBucket3SearchInputs'
import { claimsCols } from '@/ui.config/cols/claimsBucket3ClaimsCols'

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

let indexOfObject = function (array, prop, value) {
    for (var i = 0; i < array.length; i += 1) {
        if (array[i][prop] === value) {
            return i;
        }
    }
    return -1;
}

export default {
        name: 'ClaimsBucket3',
        props: ['ignoreTaskFlags'],
    mixins: [
        claimsSearch,
    ],
    components: {
        PageHeader,
        DataList,
        'data-list-pagination': DataListPagination,
        'data-list-csv': DataListCSV,
        'select-task': SelectTask,
        PageSize,
        OrderBy,
        SearchForm,
        Loading
    },
    data: () => {
        return {
            pageHeader: {
                title: 'Excess Payments',
            },
            searchInputs: searchInputs,
            claimsCols: claimsCols,

            /*--------------------------------------------------------*/
            selectedOrderBy: null, //{ orderBy: { id: 0, key: "CardPaymentDate", label: "Payment Date" }, direction: "DESC" },

            //orderBy: 'CardPaymentDate',
            //sortDirection: 'DESC',
            /*--------------------------------------------------------*/

            insuranceLineTypes: [
                {
                    id: 1,
                    label: 'GADGET'
                },
                {
                    id: 2,
                    label: 'TIGA'
                },
                {
                    id: 5,
                    label: 'POLICE FED'
                }
            ],

            // Override mixin
            orderByOptions: [
                {
                    id: 0,
                    key: 'CardPaymentDate',
                    label: 'Payment Date'
                }
            ]
        }
    },
    beforeMount() {
        //this.claimsSearch(null, 1)
        this.fetchIncidentTypes()
        this.fetchResellers()
        this.fetchUnderwriters()
        },
        mounted() {
            this.clearClaimsList()
        },
    computed: {
        taskOptions() {
            return [
                { text: 'Updated EVO with excess card payment', value: '1005' }
            ]
        },
        searchInputsEx() {
            var { searchInputs, insuranceLineTypes, incidentTypes, resellers, underwriters } = this

            if (searchInputs && searchInputs.length > 0) {

                if (insuranceLineTypes) {
                    let insuranceLineIndex = indexOfObject(searchInputs, 'id', 'insuranceLine')
                    if (insuranceLineIndex > -1) {
                        searchInputs[insuranceLineIndex].options = insuranceLineTypes
                    }
                }

                if (incidentTypes) {
                    let incidentTypeIndex = indexOfObject(searchInputs, 'id', 'incidentType')
                    searchInputs[incidentTypeIndex].options = incidentTypes
                }

                if (resellers) {
                    let resellerIndex = indexOfObject(searchInputs, 'id', 'reseller')
                    if (resellerIndex > -1) {
                        searchInputs[resellerIndex].options = resellers
                    }
                }

                if (underwriters) {
                    let underwritersIndex = indexOfObject(searchInputs, 'id', 'underwriter')
                    searchInputs[underwritersIndex].options = underwriters
                }
            }
            return searchInputs
        }
    },
    methods: {
        handleUpdateFlagsClick(evPayload) {
            let selected = evPayload

            let { selectedItems } = this
            let criteria = this.buildSearchCriteria(this.buildSearchValues(this.searchPayload))
            this.selectedItems = []
            this.selected = null
            this.showFlag = false

            this.updateClaimsPayTaskFlags(
                {
                    claimSearchCriteria: criteria,
                    claims: selectedItems.map(i => {
                        return {
                            claimId: i.claimId,
                            rowVersion: i.claimRowVersion
                        }
                    }),
                    taskFlags: selected
                }
            )
        },
        // Override mixin
        buildSearchValues(payload) {
            console.log('payload: ', payload)
            if (payload != null) {
                console.log('payload: ', payload)
                let { claimReference, imei, relatedReference, serial, processorToken, insuranceLine, incidentType, reseller, underwriter } = payload

                let criteria = {
                    claimReference: claimReference,
                    relatedReference,
                    imei: imei,
                    serial,
                    processorToken,
                    insuranceLineId: insuranceLine ? insuranceLine.id : null,
                    incidentTypeId: incidentType ? incidentType.id : null,
                    resellerId: reseller ? reseller.id : null,
                    underwriterId: underwriter ? underwriter.id : null
                }

                return criteria
            } else {
                return null
            }
        },
        // Override Mixin
        buildSearchCriteria(searchValues, pageNumber) {
            let ordering = {
                orderBy: this.orderBy,
                sortDirection: this.sortDirection
            }

            let pages = {
                pageSize: this.pageSize,
                pageNumber: pageNumber
            }

            let criteria = {
                ...searchValues,
                ignoreTaskFlag: this.ignoreTaskFlags,
                ...ordering,
                ...pages
            }

            return criteria
        },
        // Override mixin
        claimsSearch(searchValues, pageNumber) {
            this.clearClaimsList()

            let criteria = this.buildSearchCriteria(searchValues, pageNumber)
            this.fetchClaimsExcessCardPaymentsFilterPagenated(criteria)
        },
        // Override mixin
        handleSearchClick(payload) {

            if (payload != null) {
                this.searchPayload = payload

                let criteria = this.buildSearchValues(payload)

                this.claimsSearch(criteria, 1)
            } else {
                this.claimsSearch(null, 1)
            }
        },
    }
}
</script>

<style>

</style>
